/** Every `macrotide.*` localStorage key — the session, the active gym, the barcode cache, setup progress, the
 * cached `/config` and in-app messages and their dismissals, and the push installation id — plus Mantine's own
 * colour-scheme key (docs/legal/cookies.md), cleared on sign-out and on account deletion. A plain function (not a
 * hook) so it has no provider to sit under, and both `useSignOutAndClear` (auth/) and `DeleteAccountAction`
 * (features/account/) can call it without importing each other. */
export function clearLocalStorage(): void {
  try {
    for (const key of Object.keys(window.localStorage).filter((key) => key.startsWith('macrotide.'))) {
      window.localStorage.removeItem(key)
    }
    window.localStorage.removeItem('mantine-color-scheme-value')
  } catch {
    // Blocked storage held nothing to clear.
  }
}
